<div class="privacy" *ngIf="policy">
  <h1 class="heading-l">{{ policy.title }}</h1>
  <div [class.modal__scrollable]="scroll === true">
    <markdown ngPreserveWhitespaces>
      {{ policy.content }}
    </markdown>
  </div>
</div>
